import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { PanelComponent }   from '@libs/front/components/panel/panel.component';
import { MetabaseDashboardComponent } from 'src/app/shared/components/metabase-dashboard/metabase-dashboard.component';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { DeviceService }     from 'src/app/services/device.service';
import { RegionDto, Region } from 'src/app/bo/region';

@Component({
  selector:    'app-area-dashboard',
  standalone:  true,
  imports:     [CommonModule, PanelComponent, MetabaseDashboardComponent],
  templateUrl: './area-dashboard.component.html',
  styleUrls:   ['./area-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaDashboardComponent implements OnChanges {

  @Input() region: RegionDto | null = null;

  private readonly utilService = inject(UtilisateurService);
  readonly device              = inject(DeviceService);

  /** Contrôle le montage de app-metabase-dashboard pour forcer le rechargement de l'iframe */
  loadMetabase = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['region'] && this.region) {
      // Expose la région au MetabaseDashboardComponent via UtilisateurService
      const r = new Region();
      r.regionId = this.region.regionId;
      r.nom      = this.region.nom;
      r.nbSites  = this.region.sites?.length ?? 0;
      this.utilService.currentRegionForSetupRegion = r;

      // Force le rechargement de l'iframe
      this.loadMetabase.set(false);
      setTimeout(() => this.loadMetabase.set(true), 100);
    }
  }

  get sitesCount(): number {
    return this.region?.sites?.length ?? 0;
  }
}
